define('views/modals/organization/index',['require','jquery','underscore','chaplin','views/base/modal','views/modals/organization/content'],function(require) {
    'use strict';

    var $ = require('jquery'),
        _ = require('underscore'),
        Chaplin = require('chaplin'),
        ModalView = require('views/base/modal'),
        OrganizationModalContentView = require('views/modals/organization/content');

    var OrganizationModalView = ModalView.extend({
        listen: {
            'action model': 'handleAction',
            'afterLoad model': 'afterLoadContent',
            'addFavoriteSeller mediator': 'onAddFavoriteSeller',
            'removeFavoriteSeller mediator': 'onRemoveFavoriteSeller'
        },
        initialize: function() {
            ModalView.prototype.initialize.apply(this, arguments);
            this.updateModalButtons(this.model.content.get('favoriteId'), true);
        },
        afterLoadContent: function(){
            this.updateModalButtons(this.model.content.get('favoriteId'));
        },
        updateModalButtons: function(favoriteId, hideAllExceptCancel){
            var buttons = _.cloneDeep(this.model.get('buttons'));
            _.each(buttons, function(button){ button.hidden = false; });

            if(hideAllExceptCancel){
                _.each(buttons, function(button){
                    if(button.action !== 'cancel'){
                        button.hidden = true;
                    }
                });
            }else{
                var bIndex = _.findIndex(buttons, {action: (favoriteId ? 'save' : 'remove') });
                if(bIndex !== -1){
                    buttons[bIndex].hidden = true;
                }
            }

            this.model.set('buttons', buttons);
        },
        render: function() {
            ModalView.prototype.render.apply(this, arguments);
            $('html').addClass('modal-visible');
            this.subview('content', new OrganizationModalContentView({ model: this.model.content }));
        },
        handleAction: function(action, cancel) {
            if (action === 'save' || action === 'remove'){
                cancel();

                var model = this.model.content;
                var favoriteId = model.get('favoriteId');

                if (favoriteId) {
                    Chaplin.mediator.execute('removeFavoriteSeller', favoriteId);
                } else {
                    Chaplin.mediator.execute('addFavoriteSeller', model.get('id'));
                }
            }
        },
        onAddFavoriteSeller: function(item) {
            this.model.content.set('favoriteId', item.id);
            this.updateModalButtons(item.id);
        },
        onRemoveFavoriteSeller: function() {
            this.model.content.set('favoriteId', null);
            this.updateModalButtons();
        },
        dispose: function() {
            if (this.disposed) { return; }

            if(!this.model.get('dontRemoveHtmlClass')){
                $('html').removeClass('modal-visible');
            }

            ModalView.prototype.dispose.apply(this, arguments);
        }
    });

    return OrganizationModalView;
});

